<router-outlet *ngIf="!interop"></router-outlet>

<!-- Spinner for Matrix Route -->
<div class="matrix-spinner" *ngIf="isMatrixRoute && spinnerService.getdisplayValue()">
  <div class="wrapper">
    <div class="wheel"></div>
  </div>
</div>

<!-- LEGACY: change *ngIf to remove "!isMatrixRoute" to rollback -->
<div  class="main-container" *ngIf="!isMatrixRoute" [class.hidden-container]="isMatrixRoute">
                <div *ngIf="!ciscolive && !interop" class="app-container">
                        <!-- <div> <app-header></app-header></div>. -->
                            <br><br>
                            <div class="loading-spinner flex-center"  *ngIf="spinnerService.getdisplayValue()">
                                    <div class="wrapper">
                                        <div class="wheel"></div>
                                    </div>
                            </div>

                            <div *ngIf="urlbanners && !isMatrixRoute">
                                <app-adminbanner></app-adminbanner>
                            </div>
                            <div *ngIf = !urlbanners>
                                <div class="head">
                                        <div class="row">
                                            <div class="message">
                                                <h3>Cisco Optics-to-Device Compatibility Matrix</h3>
                                                <div class="col-md-12 col-lg-12" style="padding-left:0px;">
                                                    <b><font color="red">Disclaimer: </font></b>Cisco makes the data in this tool available for informational purposes. Cisco does not represent, warrant, or guarantee that it is complete, accurate, or up to date. This information is subject to change without notice.
                                                 </div>
                                                <div class="alert"  style="border:none" id= "{{i}}info"  *ngFor="let info of messageDetails?.info; trackBy: trackByIndex; let i=index">
                                                    <div class="alert__icon icon-info-circle"></div>
                                                    <div class="alert__message" [innerHTML]="info"> </div>
                                                    <span class="alert__close icon-close" (click)="close($event,i,'info')"></span>
                                                </div>

                                                <div class="alert alert--warning" id= "{{i}}warn" *ngFor="let warn of messageDetails?.warn; trackBy: trackByIndex; let i=index">
                                                    <div class="alert__icon icon-exclamation-triangle"></div>
                                                    <div class="alert__message" [innerHTML]="warn"> </div>
                                                    <span class="alert__close icon-close" (click)="close($event,i,'warn')"></span>
                                            
                                                </div>
                                                <div class="alert alert--danger" id= "{{i}}danger" *ngFor="let danger of messageDetails?.error; trackBy: trackByIndex; let i=index">
                                                    <div class="alert__icon icon-error"></div>
                                                    <div class="alert__message" [innerHTML]="danger"> </div>
                                                    <span class="alert__close icon-close" (click)="close($event,i,'danger')"></span>
                                                </div>
                                            </div>
                                            <div class = " col-md-5">
                                                <div class = "col-md-12 col-md-offset-0" style="padding: 0px">
                                                <carousel class="text-center" [interval]="timeDelay">
                                                <slide *ngFor = "let banner of _banners; trackBy: trackByBanner">
                                                    <a (click)="eventEmit(banner.title)" target="_blank" href = "{{banner.imageUrl}}">
                                                    <img src="{{banner.image_blob}}" class="img-main-size">
                                                    <div class = "carousel-caption d-none d-md-block">
                                                        <p align="left" style="font-size: 0.76vw; line-height: 1.5; overflow: hidden;height: 48%;margin:2% 0% 0% 0%"><span [innerHTML] = "banner.title"></span></p>
                                                        <p align="left" style="font-size: 0.76vw; line-height: 1.5; height: 36%;margin:0% 0% 0% 0%"><span [innerHTML] = "banner.description"></span></p>
                                                    </div>
                                                    </a>
                                                </slide> 
                                                </carousel>
                                                </div>
                                            </div>  
                                        </div>
                                        <div class="alert alert--success" id="success" (scroll)="stickDiv($event)" *ngIf="uploadResponse != undefined && showSuccess">
                                            <div class="alert__icon icon-check"></div>
                                            <div class="alert__message" >{{uploadResponse.message}}</div>
                                            <div class="alert__close icon-close" (click)="closeRes('success')"></div>
                                        </div>
                                        <div class="alert alert--danger" id="success" (scroll)="stickDiv($event)" *ngIf="uploadResponse != undefined && showFail" >
                                            <div class="alert__icon icon-error">{{uploadResponse.message}}</div>
                                            <div class="alert__message"></div>
                                            <div class="alert__close icon-close" (click)="closeRes('fail')"></div>
                                        </div>
                                        <div class="alert alert--warning" id="success" (scroll)="stickDiv($event)" *ngIf="uploadResponse != undefined && showwarn">
                                            <div class="alert__icon icon-exclamation-triangle"></div>
                                            <div class="alert__message">{{uploadResponse.message}}</div>
                                            <div class="alert__close icon-close" (click)="closeRes('warn')"></div>
                                        </div>
                                </div>

                                <div class="box-sizing">
                                    <app-home (uploadResponse)="setuploadResponse($event)"></app-home>
                                </div>
                            </div>
                            <!-- <app-footer></app-footer> -->
                    

                </div>

    
            <!-- <div *ngIf="ciscolive" class="app-container">
                 <div><app-cisco-live-header [showButton]="showButton" (buttonValue)="showingButton($event)" (goBackValue)="goBackToParent($event)" ></app-cisco-live-header></div>
                    <div class="loading-spinner flex-center"  *ngIf="spinnerService.getdisplayValue()">
                        <div class="wrapper">
                            <div class="wheel"></div>
                        </div>
                    </div>
                    <div>
                    <app-cisco-live-home (showBAckButton)="showingButton($event)" [parent]="parent" ></app-cisco-live-home>
                    </div>  
                    <div><app-landing-page></app-landing-page></div>
            </div> -->
            <div *ngIf="interop">
                <interopapp-root></interopapp-root>
            </div>

    </div>

    <section>
        <a href="https://engage2demand.cisco.com/LP=28220" target="_blank"
        class="btn btn--primary" alt="Contact Cisco" 
        title="Contact Cisco" id="menubutton">
          <span class="pri-4 btn-txt">Contact Sales</span>
        </a>
    
      </section>

    
    